<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Unit Information</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (modelSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Model:</label>
              <select class="halfWidthInputField" #modelInput
                [class.invalidConfigurationSelection]="isInvalidSelection(modelSelection.Name)"
                (change)="selectionChanged(modelSelection, modelInput.value)"
                [value]="modelSelection.Value.toString()">
                @for (allowable of modelSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="modelSelection.Value && modelSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (configurationSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Configuration:</label>
              <select class="halfWidthInputField" #configurationInput
                [class.invalidConfigurationSelection]="isInvalidSelection(configurationSelection.Name)"
                (change)="selectionChanged(configurationSelection, configurationInput.value)"
                [value]="configurationSelection.Value.toString()">
                @for (allowable of configurationSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="configurationSelection.Value && configurationSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (sizeSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Size:</label>
              <select class="halfWidthInputField" #sizeInput
                [class.invalidConfigurationSelection]="isInvalidSelection(sizeSelection.Name)"
                (change)="selectionChanged(sizeSelection, sizeInput.value)"
                [value]="sizeSelection.Value.toString()">
                @for (allowable of sizeSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="sizeSelection.Value && sizeSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
